import { TApplicationStep } from '~/store/types.ts';

export const PROCESSING_PERSONAL_SUBMIT_STEPS: TApplicationStep[] = [
  { title: 'Верифікація' },
  { title: 'Заповнення даних' },
  { title: 'Перегляд документу' },
  { title: 'Підпис документу' },
];

export const PROCESSING_PERSONAL_REVOKE_STEPS: TApplicationStep[] = [
  { title: 'Верифікація' },
  { title: 'Заповнення даних' },
  { title: 'Перегляд документу' },
  { title: 'Відкликання заяви' },
];
